import { ref, computed, type Ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';
import { PAPER_WIDTH_RATIO, MIN_PAPER_WIDTH } from '../lib/canvas-constants';

export interface CanvasResponsiveWidthOptions {
  widthRatio?: number;
}

export function useCanvasResponsiveWidth(
  containerRef: Ref<HTMLElement | null>,
  { widthRatio = PAPER_WIDTH_RATIO }: CanvasResponsiveWidthOptions = {}
) {
  const containerWidth = ref(0);

  const displayWidth = computed(() => {
    const available = Math.floor(containerWidth.value * widthRatio);
    return Math.max(MIN_PAPER_WIDTH, available);
  });

  useResizeObserver(containerRef, (entries) => {
    const entry = entries[0];
    if (entry) {
      containerWidth.value = entry.contentRect.width;
    }
  });

  return { displayWidth, containerWidth };
}
